// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SO9Eu","rootNoMargin":"styles_rootNoMargin__2yELR"};